var _rect, _rect2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 238974"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 513",
    x: 0.429688,
    width: 16,
    height: 16,
    rx: 4,
    fill: "#D1DCFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "keyboard_arrow_down"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7_1737",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 13,
    height: 12
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 2.61157,
    y: 2.18185,
    width: 11.6364,
    height: 11.6364,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7_1737)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "keyboard_arrow_down_2",
    d: "M8.42887 9.64864L5.51978 6.73955L6.19856 6.06076L8.42887 8.29106L10.6592 6.06076L11.338 6.73955L8.42887 9.64864Z",
    fill: "#243B86"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.7cd4674b1aa1f533ef3c6c9a3438ceba.svg";
export { ForwardRef as ReactComponent };